import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import './SettingsModal.css';

import Modal from '../common/Modal/Modal';
import InputField from '../common/InputField/InputField';
import Button from '../common/Button/Button';
import config from '../../dashboard_config.json';

const { primaryNameDisplayMaxLength, outputNameDisplayMaxLength } = config.dashboard.primaryAndOutputDisplayNameSettings;

class SettingsModal extends React.PureComponent {
  state = {
    displayedName: '',
    isDesignatedOutput: '',
    isDesignatedOutputEdited: false,
    showErrorMessage: false,
    maxNameLength: '',
  };

  componentDidUpdate(prevProps) {
    const { type, displayedName, isDesignatedOutput } = this.props;
    if (type !== prevProps.type) {
      const maxNameLength = type === 'Primary' ? primaryNameDisplayMaxLength : outputNameDisplayMaxLength;
      this.setState({ maxNameLength });
    }

    if (displayedName !== prevProps.displayedName) {
      this.setState({ displayedName });
    }

    if (isDesignatedOutput !== prevProps.isDesignatedOutput) {
      this.setState({ isDesignatedOutput });
    }
  }

  handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= this.state.maxNameLength) {
      this.setState({
        displayedName: value,
        showErrorMessage: false,
      });
    } else {
      this.setState({ showErrorMessage: true });
    }
  };

  handleCheckboxChange = (e) => {
    this.setState({
      isDesignatedOutput: e.target.checked,
      isDesignatedOutputEdited: true,
    });
  };

  handleSaveClick = () => {
    const { type, id, setDisplayedName, setDesignatedOutput } = this.props;

    setDisplayedName(type, id, this.state.displayedName);

    if (type === 'Output' && this.state.isDesignatedOutputEdited === true) {
      setDesignatedOutput(id, this.state.isDesignatedOutput);
    }

    this.setState({
      displayedName: '',
      showErrorMessage: false,
      isDesignatedOutput: '',
      isDesignatedOutputEdited: false,
    });
  };

  handleResetClick = () => {
    this.setState({ displayedName: '' }, () => {
      this.handleSaveClick();
    });
  };

  render() {
    const { type, name, uuid, handleGuidCopyIconClick } = this.props;
    const { displayedName, isDesignatedOutput, showErrorMessage } = this.state;

    let headerTitle;
    if (type === 'Primary') {
      headerTitle = `Change "${name}" Display Name`;
    } else if (type === 'Output') {
      headerTitle = `Change "${name}" Settings`;
    }

    return (
      <Modal
        uniqueId="setting-displayed-name-modal"
        type={this.props.type}
        hideHeader={true}
        containerClass="modal-dialog-centered settings-modal-container premium-logout-modal"
        buttons={[
          { name: 'Save', className: 'premium-logout-btn-confirm', clickHandler: this.handleSaveClick },
          { name: 'Cancel', className: 'premium-logout-btn-cancel' }
        ]}
        bodyClass="premium-modal-body settings-modal-body"
      >
        <div className="logout-content settings-modal-content">
          <i className="material-icons logout-warning-icon settings-modal-icon">settings</i>
          <p style={{ fontSize: '1.1rem', fontWeight: '500', color: '#ccc' }}>
            {headerTitle}
          </p>

          <div className="input-container displayed-name-output-input-container w-100 text-left">
            <label htmlFor="displayed-name-input" className="mb-0">Display Name:</label>
            <InputField
              uniqueId="displayed-name-input"
              labelName=""
              type="text"
              value={displayedName}
              changeHandler={this.handleInputChange}
            />
            <i
              className={`material-icons settings-reset-icon ${!this.props.displayedName ? 'disabled' : ''}`}
              title={this.props.displayedName ? "Reset to default" : ""}
              onClick={this.props.displayedName ? this.handleResetClick : undefined}
            >
              history
            </i>
          </div>

          <div className={`text-danger ${showErrorMessage ? 'd-block' : 'd-none'}`} style={{ fontSize: '0.8rem' }}>
            <strong>The name is too long</strong> (maximum {this.state.maxNameLength} characters)
          </div>

          {type === 'Output' && (
            <Fragment>
              <div className="custom-control custom-checkbox w-100 text-left">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="designatedOutputCheckbox"
                  checked={isDesignatedOutput}
                  onChange={this.handleCheckboxChange}
                />
                <label className="custom-control-label" htmlFor="designatedOutputCheckbox">
                  Designated output
                </label>
              </div>
              <div className="guid-container w-100 text-left d-flex align-items-center">
                <label className="mb-0">GUID:</label>
                <span className="guid-value flex-grow-1 mx-2">{uuid}</span>
                <i
                  className="material-icons settings-copy-icon"
                  title="Copy GUID"
                  onClick={() => handleGuidCopyIconClick(uuid)}
                >
                  content_copy
                </i>
              </div>
            </Fragment>
          )}
        </div>
      </Modal>
    );
  }
}

SettingsModal.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  displayedName: PropTypes.string.isRequired,
  isDesignatedOutput: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  uuid: PropTypes.string.isRequired,
  setDisplayedName: PropTypes.func.isRequired,
  handleGuidCopyIconClick: PropTypes.func.isRequired,
  setDesignatedOutput: PropTypes.func.isRequired,
  companyType: PropTypes.number,
};

export default SettingsModal;
